import { Shield } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400" data-testid="landing-footer" id="about">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <Shield className="w-[18px] h-[18px] text-white" />
              </div>
              <span className="font-heading font-semibold text-lg text-white tracking-tight">easypermit</span>
            </div>
            <p className="text-sm leading-relaxed">The approvals and readiness operating system for builders, surveyors, and permit coordinators.</p>
            <p className="text-xs text-slate-500 mt-3">Stop permit delays before they stall the next stage.</p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Builder Flow</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/builder" className="hover:text-white transition-colors">Builder Overview</Link></li>
              <li><Link to="/builder/new-mail" className="hover:text-white transition-colors">New Approvals Mail</Link></li>
              <li><Link to="/builder/rfi-war-room" className="hover:text-white transition-colors">Council Requests</Link></li>
              <li><Link to="/builder/stage-conditions" className="hover:text-white transition-colors">Stage Conditions</Link></li>
              <li><Link to="/builder/stage-readiness" className="hover:text-white transition-colors">Stage Readiness</Link></li>
              <li><Link to="/builder/trade-release" className="hover:text-white transition-colors">Trade Release</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">Readiness</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/builder/proof-review" className="hover:text-white transition-colors">Proof Review</Link></li>
              <li><Link to="/builder/inspection-readiness" className="hover:text-white transition-colors">Inspection Readiness</Link></li>
              <li><Link to="/builder/site-ready-pack" className="hover:text-white transition-colors">Site Ready Pack</Link></li>
              <li><Link to="/builder/pre-submission-check" className="hover:text-white transition-colors">Handover Check</Link></li>
              <li><Link to="/shared/client-portal" className="hover:text-white transition-colors">Client Portal</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-4">About</h4>
            <ul className="space-y-2.5 text-sm">
              <li><span className="cursor-default">Concept Demo</span></li>
              <li><span className="cursor-default">Built in Australia</span></li>
              <li><span className="cursor-default">For the messy middle of approvals</span></li>
              <li><span className="cursor-default">Stage readiness is the moat</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">Concept mockup for feedback. You still lodge. Guidance only.</p>
          <p className="text-xs text-slate-600">easypermit is not legal advice, does not certify, and does not lodge permits.</p>
        </div>
      </div>
    </footer>
  );
}
